<body>
    <mat-card class="card"> <img class="logo1" src="../../../assets/img/flat-lay-photography-of-vegetable-salad-on-plate-1640777.jpg">
        <form class="main"  [formGroup]="addForm" (ngSubmit)="verify(addForm.value)">
            
                <span class="title">Change Password</span>
                <span></span>
                <div class="row1">
                    <mat-form-field  class="search1"><mat-label>Email</mat-label>
                        <input type="email" matInput placeholder="Email" formControlName="email" name="email"></mat-form-field> 
                </div>     
                <div class="row1">
                    <mat-form-field  class="search1"><mat-label>Old Password</mat-label>
                        <input type="password" matInput placeholder="Old Password" formControlName="old" name="old"></mat-form-field> 
                </div>            
                <div class="row1">
                    <mat-form-field>
                        <mat-label>New Password</mat-label>
                    <input type="password"  matInput placeholder="New Password" formControlName="new" name="new">
                </mat-form-field> 
                </div>
                <div class="row1">
                        <button  mat-button class="btn1">Change Password</button>
               
                </div>
            </form>    
        </mat-card>
    </body>